import { useContext } from 'react'

import { AuthContext } from 'context/AuthContext'

/**
 * @typedef {Object} AuthContext
 * @property {Object} RBAC - The RBAC roles and privileges summary
 * @property {string} authHeader - The authorization header used for requests
 * @property {string} companyDisplayName - Preferred display name of the company
 * @property {string} companyId - ID of company
 * @property {boolean} companyIsAlfiEnabled
 * @property {Object} companyPrefs
 * @property {Array} companyPrivileges
 * @property {boolean} contractExpirationImminent
 * @property {Object} currentTeam
 * @property {string} currentTeamId
 * @property {Array} currentTeamRoles
 * @property {number} daysUntilContractExpiration
 * @property {function} endSession
 * @property {function} fetchSession
 * @property {function} getTeamDetails
 * @property {boolean} hasCompanyPrivilege
 * @property {boolean} hasElevatedCompanyRole
 * @property {boolean} hasElevatedRole
 * @property {boolean} hasElevatedTeamRole
 * @property {boolean} hasTeamPrivilege
 * @property {boolean} hasUpgradeBeenRequested
 * @property {boolean} isAdmin
 * @property {boolean} isFreeEdition
 * @property {boolean} isRbacEnabled
 * @property {boolean} isSuper
 * @property {Array} privilegesForTeam
 * @property {boolean} ready
 * @property {function} renewSession
 * @property {Array} roles
 * @property {Object} session
 * @property {function} setActiveTeamId
 * @property {function} startSession
 * @property {Array} teams
 * @property {string} tier
 */

/**
 * Returns the auth context via hook
 * @return {AuthContext}
 *         The auth context
 */
export default function useAuth() {
  const authContext = useContext(AuthContext)
  return authContext
}
